import { Data } from '../../../interfaces/Data';

export default class Rg{
    Numero: string;
    DataEmissaoRg: Data =new Data();
    UfEmissaoRg: string;
    OrgaoEmissor?: string;

    constructor(){}
}